import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IbSubscriptionModelsNewConfirmationComponent } from './ib-subscription-models-new-confirmation.component';
import { NgReactModule } from '@src/app/react/ng-react.module';
import { TranslateModule } from '@ngx-translate/core';
import { UpgradeModule } from '@angular/upgrade/static';



@NgModule({
    declarations: [
        IbSubscriptionModelsNewConfirmationComponent
    ],
    imports: [
        CommonModule,
        // UpgradeModule,
        TranslateModule,
        NgReactModule
    ],
    exports: [
        IbSubscriptionModelsNewConfirmationComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class IbSubscriptionModelsNewConfirmationModule { }
export { IbSubscriptionModelsNewConfirmationComponent } from './ib-subscription-models-new-confirmation.component';
